import { supabase } from '@/integrations/supabase/client';

export async function getPlayerById(id: string) {
  // Try to fetch by id or unique_id
  const { data, error } = await supabase
    .from('players')
    .select('*')
    .or(`id.eq.${id},unique_id.eq.${id}`)
    .single();

  if (error || !data) {
    throw new Error('Player not found');
  }
  return {
    id: data.id,
    name: data.name,
    role: data.role,
    avatarUrl: data['profile_picture_url'] || '',
    ...data,
  };
}

export async function getTeamById(id: string) {
  // Try to fetch by id or unique_id
  const { data, error } = await supabase
    .from('teams')
    .select('*')
    .or(`id.eq.${id},unique_id.eq.${id}`)
    .single();

  if (error || !data) {
    throw new Error('Team not found');
  }
  const team = data as typeof data & { logo_url?: string };
  return {
    id: team.id,
    name: team.name,
    shortCode: team.short_code,
    color: team.color,
    logoUrl: team.logo_url ?? '',
    ...team,
  };
} 